import { render, staticRenderFns } from "./InvoicesDHLFedExTNTTableMobile.vue?vue&type=template&id=81b381e2&scoped=true"
import script from "./InvoicesDHLFedExTNTTableMobile.vue?vue&type=script&lang=js"
export * from "./InvoicesDHLFedExTNTTableMobile.vue?vue&type=script&lang=js"
import style0 from "./InvoicesDHLFedExTNTTableMobile.vue?vue&type=style&index=0&id=81b381e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b381e2",
  null
  
)

export default component.exports